.linkRow {
  margin: 1rem 0 1rem 5.625rem;
}
